/**
 * @generated SignedSource<<1ea424b6f6231a7f47256c4aa90dea66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestAccountLoginLink_userExistsMetadata$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutAuthActions_userExistsMetadata">;
  readonly " $fragmentType": "CheckoutGuestAccountLoginLink_userExistsMetadata";
};
export type CheckoutGuestAccountLoginLink_userExistsMetadata$key = {
  readonly " $data"?: CheckoutGuestAccountLoginLink_userExistsMetadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestAccountLoginLink_userExistsMetadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestAccountLoginLink_userExistsMetadata",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutAuthActions_userExistsMetadata",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasFacebook",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasGoogle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasApple",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailOnly",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "UserExistsMetadataType",
  "abstractKey": null
};

(node as any).hash = "342cac3eafd1c9f4792a0fba372f80ec";

export default node;
